import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useLoan from 'hooks/useLoan';

import history from 'navigation/history';

import { COLLECTION } from 'utils/enumerator/enum-loan-phase';
import { manageEvents } from 'utils/helper/datalayer-events-helper';
import { APPLICATION_PENDING_DATA_CAPTURE_APP_INSTALLATION } from 'utils/enumerator/enum-loan-state';

import Container from 'components/templates/container/container';
import Header from 'components/templates/header/header';
import FooterComponent from 'components/templates/footer/footer';

import { SessionDataHelper } from './utils/helper/session-data-helper';
import { logged } from './store/actions/auth-actions';

import { Navbar } from "lib-ui-react";
import { loanHasProductTypeEqualTo } from 'utils/helper/loan-helper';
import { EMPRESTIMO_SIM, ADIANTA_SIM } from 'utils/enumerator/enum-products';

export default function MainComponent({ children }) {
  const { loan } = useLoan();
  const showHeaderOriginalHeader = !([APPLICATION_PENDING_DATA_CAPTURE_APP_INSTALLATION].includes(loan.state.id) && loanHasProductTypeEqualTo(loan, EMPRESTIMO_SIM));
  const showFooter = useSelector((state) => state?.utilReducer?.showFooter);
  const dispatch = useDispatch();

  const showContacts = !loanHasProductTypeEqualTo(loan, ADIANTA_SIM);

  const getAuthentication = async () => {
    const response = await dispatch(logged());

    if (response.payload == false) localStorage.removeItem('loggedIn');
  };

  useEffect(() => {
    SessionDataHelper.createGaClientIdStorageEntry();
    SessionDataHelper.createUtmsCookies();
  }, []);

  useEffect(() => {
    getAuthentication();

    const params = new URLSearchParams(history.location?.search);

    // decorate URL for late installments
    // Use this in google analytics
    if (loan && loan.state?.phase?.id == COLLECTION && !params.get('phase')) {
      params.append('phase', COLLECTION);
      history.replace({ search: params.toString() });
    }

    // Set the events on datalayer.
    manageEvents(loan);

    if (params.get('autoSign')) {
      sessionStorage.setItem('autoSign', params.get('autoSign'));
    }

    if(params.get('multiOffer')){
      sessionStorage.setItem('multiOffer', params.get('multiOffer'));
    }

    if (params.get('autoSignExpired')) {
      sessionStorage.setItem('autoSignExpired', params.get('autoSignExpired'));
    }
  }, [loan]);

  return (
    <Container>
      <div>
        {showHeaderOriginalHeader ?
        <Header /> :
        <Navbar
          logo={<img src="/image/logo_play_store.png" alt="Logo" width="54" height="54" />}
          background="#fafafa"
          style={{padding: '2% 2% 2% 5%'}}
        />}
        {children}
      </div>
      <FooterComponent showFooter={showFooter} showContacts={showContacts} />
    </Container>
  );
}
